import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
  model,
  output,
} from '@angular/core';
import { debounceTime, fromEvent } from 'rxjs';
import { LayoutStore } from '../stores/layout.store';

type ScrollType = 'window' | 'element' | 'layout';

@Directive({
  selector: '[appInfiniteScroll]',
})
export class InfiniteScrollDirective implements AfterViewInit {
  readonly layoutStore = inject(LayoutStore);

  hasNext = input<boolean>(false);
  next = output<void>();

  type = model<ScrollType>('window');

  constructor(private readonly el: ElementRef) {}

  ngAfterViewInit(): void {
    switch (this.type()) {
      case 'window':
        fromEvent(window, 'scroll')
          .pipe(debounceTime(300))
          .subscribe(() => {
            const scrollPosition = window.innerHeight + window.scrollY;
            const threshold = document.body.offsetHeight - 100;
            if (scrollPosition > threshold) {
              if (this.hasNext() && this.next) {
                this.next.emit();
              }
            }
          });
        break;
      case 'element':
        fromEvent(this.el.nativeElement, 'scroll')
          .pipe(debounceTime(300))
          .subscribe(() => {
            const scrollPosition =
              this.el.nativeElement.scrollTop +
              this.el.nativeElement.clientHeight;
            const threshold = this.el.nativeElement.scrollHeight - 100;

            if (scrollPosition > threshold) {
              if (this.hasNext() && this.next) {
                this.next.emit();
              }
            }
          });
        break;
      case 'layout':
        this.layoutStore.layoutScrollEvent$.subscribe({
          next: (event) => {
            if (event) {
              const scrollPosition = event.scrollTop + event.clientHeight;
              const threshold = event.scrollHeight - 100;
              if (scrollPosition > threshold) {
                if (this.hasNext() && this.next) {
                  this.next.emit();
                }
              }
            }
          },
        });
        break;
    }
  }
}
